<div class="main-content" id="main-content">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="br-breadcrumb">
            <ul class="crumb-list">
              <li class="crumb home">
                <a class="br-button circle" [routerLink]="['/']">
                  <span class="sr-only">Página inicial</span>
                  <i class="fas fa-home"></i
                ></a>
              </li>
              <li class="crumb" data-active="active">
                <i class="icon fas fa-chevron-right"></i>
                <span>Tabela de Submissão</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="page-header">
            <div id="page-title" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h2>Tabela de Submissão</h2>
                <p>
                  Nesta tabela de submissão estão listados os cursos cuja
                  entrada no Catálogo foi recusada, ou ainda cursos que foram
                  retirados do Catálogo por não terem mais oferta. A recusa se
                  deu porque já existe no Catálogo curso com formação
                  semelhante, o curso proposto se enquadra como qualificação
                  profissional ou especialização técnica ou ainda pode ter sido
                  por conflito com norma regulamentadora de profissão. Desta
                  forma, recomenda-se que tais cursos não sejam mais oferecidos,
                  a menos que sejam adaptados para perfis que já constam no
                  Catálogo.
                </p>
              </div>
            </div>

            <!-- <app-barra-busca [componenteRef]="componenteRef" (inputEvent)="recebeuInput($event)" [filtros]="false">
            </app-barra-busca> -->

            <div id="page-data-share" class="row">
              <div
                id="page-data"
                class="col-xs-12 col-sm-8 col-md-8 col-lg-8"
              ></div>
              <div
                id="page-share"
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
              >
                <span>Gerar:</span>
                <div class="share-buttons">
                  <a
                    class="br-button tertiary circle mr-3"
                    (click)="downloadPdfCursosSubmissao()"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </a>
                  <a
                    class="br-button tertiary circle mr-3"
                    (click)="downloadCsvCursosSubmissao()"
                  >
                    <i class="fas fa-file-csv"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div id="page-content">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <table
                  class="submission"
                  *ngFor="let curso of cursosTabelaSubmissao"
                >
                  <thead>
                    <tr>
                      <th class="text-center">EIXO TECNOLÓGICO</th>
                      <th class="text-center border-left">DENOMINAÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="area" rowspan="40">
                        <strong
                          [innerHTML]="curso.eixoNome | uppercase"
                        ></strong>
                      </td>
                    </tr>
                    <!-- <td class="border-left">MICROELETRÔNICA</td> -->
                    <ng-container
                      *ngIf="
                        curso.cursosSubmissaoPorEixo &&
                        curso.cursosSubmissaoPorEixo.length > 0
                      "
                    >
                      <ng-container
                        *ngFor="
                          let cursoSubmissao of curso.cursosSubmissaoPorEixo
                        "
                      >
                        <tr>
                          <td
                            class="border-left"
                            [innerHTML]="cursoSubmissao.nome | uppercase"
                          ></td>
                          <ng-container
                            *ngIf="
                              curso.cursosSubmissaoPorEixo &&
                              curso.cursosSubmissaoPorEixo.length < 1
                            "
                          >
                            <td class="border-left">Não Houve alteração</td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <ng-container *ngIf="totalResultados > 0">
    <app-paginacao
      [paginaAtual]="paginaAtual"
      [totalPaginas]="totalPaginas"
      (mudouPagina)="onPaginaSelecionada($event)"
    ></app-paginacao>
  </ng-container>
</div>
